import { useFilterStore } from "./store";
import { NavigateFunction } from "react-router";

export const showSettings = () => useFilterStore.getState().showSettings();
export const hideSettings = () => useFilterStore.getState().hideSettings();
export const toggleSettings = () => useFilterStore.getState().toggleSettings();
export const filterAddAttribute = (uuid: string) =>
  useFilterStore.getState().filterAddAttribute(uuid);
export const filterRemoveAttribute = (uuid: string) =>
  useFilterStore.getState().filterRemoveAttribute(uuid);
export const filterClear = () => useFilterStore.getState().filterClear();
export const filterShow = () => useFilterStore.getState().filterShow();
export const filterHide = () => useFilterStore.getState().filterHide();
export const changeFilteringMethod = (
  newFilteringMethod: any,
  navigate: NavigateFunction
) => useFilterStore.getState().changeFilteringMethod(newFilteringMethod, navigate);
